var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 106,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7 18.5a49.3 49.3 0 0 0-17.7 21l16.4-18.8.6-.4a1.1 1.1 0 0 1 1.1 1.8l-18 24c.6.9 1.3 1.7 2.2 2.3l15 1.7a48 48 0 0 0 15.4-5.6 15 15 0 0 0-15-26Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m70 19.3-.6 2c-.1-.7-.7-1.1-1.4-1-.2 0-.4.2-.6.4L47.6 43.3c-.9-.3-1.7-.8-2.4-1.4l-5.3-11.6A47 47 0 0 1 41 11.5a15 15 0 1 1 29 7.8Zm-1 3L54.3 41.8c5.8-3.8 11.9-13 14.5-19.3ZM64.7 84.2c-.4-6.2-5-19.3-10.9-25.1l9.5 23v.7a1.1 1.1 0 0 1-2 .3L47.8 56.2c-1 .1-2 .4-3 1l-8.3 12.7A48 48 0 0 0 34.7 86a15 15 0 0 0 30-1.9Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m63.4 85.1-1.5-1.5c.6.2 1.3-.1 1.4-.8v-.7L51.9 54.4c.6-.7 1.4-1.2 2.3-1.6l12.7.4a47 47 0 0 1 16.4 9.4 15 15 0 0 1-20 22.5ZM61 82.7 50.2 61.1c.9 7 6.4 16.4 11 21.6ZM9.6 50c6.1 2.4 20.9 3.6 28.3.2l-26.6.2-.6-.2a1.1 1.1 0 0 1 .5-2l30.3-2.5h.8c.2-.6.3-1.3.2-2L36.1 32c-4-4-9.7-7.7-15.7-10A15 15 0 1 0 9.6 50Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4 48.5a50.8 50.8 0 0 1 26-2.3l-24.2 2a1.1 1.1 0 0 0-.6 2l.7.2 30.4-.2h.2v.2c.5 1 .7 2.2.7 3.4l-9.8 15A48.6 48.6 0 0 1 21.5 76 15 15 0 0 1 9.4 48.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloverIcon);
export default __webpack_public_path__ + "static/media/clover_icon.b0309f16e690509707c8beb837785078.svg";
export { ForwardRef as ReactComponent };